var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-line-chart',{attrs:{"chart-data":_vm.data,"chart-options":_vm.options,"plugins":_vm.plugins}})}
var staticRenderFns = []

export { render, staticRenderFns }